import { useEffect, useRef } from 'react';
import { Section } from './Section.jsx';
import { T } from '../T.jsx';

function lectureHref(item) {
  return item.shareHash
    ? `/s/${item.shareHash}/`
    : `/${item.owner}/${item.id}/`;
}

export function Examples({ lectures }) {
  const gridRef = useRef(null);

  // These cards arrive after the reveal observer has already fired for this
  // wrapper and unobserved it, so nothing would ever add .visible to them.
  // Staggering here is what the original did for the same reason.
  useEffect(() => {
    if (!lectures.length || !gridRef.current) return undefined;
    const timers = Array.from(gridRef.current.querySelectorAll('.fade-in:not(.visible)')).map(
      (el, i) => setTimeout(() => el.classList.add('visible'), i * 60)
    );
    return () => timers.forEach(clearTimeout);
  }, [lectures]);

  return (
    <Section>
      <section className="section" id="examples">
        <T k="ml_examples_label" className="section-label">Examples</T>
        <T k="ml_examples_heading" as="h2" className="section-heading fade-in">
          See It in Action
        </T>
        <T k="ml_examples_intro" as="p" className="section-intro fade-in">
          Browse real presentations built with MyLecture — from AI education keynotes to statistics lectures.
        </T>
        <div ref={gridRef} className="examples-grid">
          {lectures.map((item) => (
            // Titles and descriptions come from the lecture manifests and change
            // with the data, so they are rendered as plain text — wrapping them
            // in <T> would let a re-render stomp a translation in place.
            <a
              key={`${item.owner}/${item.id}`}
              className="example-card fade-in"
              href={lectureHref(item)}
              style={{ '--card-accent': item.accent }}
            >
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <span className="example-meta">{item.slides} slides</span>
            </a>
          ))}
        </div>
      </section>
    </Section>
  );
}
